import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Capabilities from "@/pages/Capabilities";
import Infrastructure from "@/pages/Infrastructure";
import Products from "@/pages/Products";
import Industries from "@/pages/Industries";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Contact from "@/pages/Contact";
import BrochureViewer from "@/pages/BrochureViewer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/capabilities/equipment" element={<Navigate to="/capabilities/infrastructure" replace />} />
              <Route path="/capabilities/infrastructure" element={<Infrastructure />} />
              <Route path="/capabilities/products" element={<Products />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/brochure" element={<BrochureViewer />} />
          </Routes>
        </SmoothScroll>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
